import { render, staticRenderFns } from "./InsectPositionsCanvas.vue?vue&type=template&id=2d118e1a&scoped=true&"
import script from "./InsectPositionsCanvas.vue?vue&type=script&lang=js&"
export * from "./InsectPositionsCanvas.vue?vue&type=script&lang=js&"
import style0 from "./InsectPositionsCanvas.vue?vue&type=style&index=0&id=2d118e1a&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d118e1a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d118e1a')) {
      api.createRecord('2d118e1a', component.options)
    } else {
      api.reload('2d118e1a', component.options)
    }
    module.hot.accept("./InsectPositionsCanvas.vue?vue&type=template&id=2d118e1a&scoped=true&", function () {
      api.rerender('2d118e1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_legacy/InsectPositionsCanvas.vue"
export default component.exports